export const SITE_DOCUMENTS_QUERY_KEY = 'siteDocuments';
